import moment from 'moment'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, Switch, Route } from 'react-router-dom'
import { DatePicker, Menu, Dropdown } from 'antd'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import { stringifyDate, useListData, useToggle, usePet, useShift } from '../../modules'

import Receive from '../../components/reusable/receive'
import Patient from '../../components/reusable/patient'

import PatientData from '../../components/drawers/patientData'


const { RangePicker } = DatePicker

let department = 'OPD'

const Patients = () => {
    const [ranges, setRanges] = useState()
    const [chosen, setChosen] = useState([])
    // const [categories, setCategories] = useState([])
    const [ptnt, setPatient] = useState()
    const [string, setString] = useState('')
    const [category, setCategory] = useState('')
    const [selected, setSelected] = useState('')

    const [select, toggleSelect] = useToggle()


    const [
        { loading: pLoading, error: pError, fetch: fetchPatients },
        { list: patients },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('patients', ranges ? { string, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null } : { string }, { notify: true })

    // const [{ loading: sLoading, error: sError }] = usePet('routingGroupNames', { hidden: false }, { notify: true, callback: ({ data }) => setCategories(data), logOutOnError: true })
    const { shift } = useSelector(state => state.application)

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const refresh = () => {
        navigate(1)
        fetchPatients()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const onComplete = (_, notif, ops) => {
        notif('Ip No has been assigned', ops('success'))
        fetchPatients()
    }

    const [, assignIpNo] = usePet('assignIpNo', {
        patient: selected
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Assigning Ip No...' } })

    const [, assignTempIpNo] = usePet('assignTempIpNo', {
        patient: selected
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Assigning Temporary Ip No...' } })

    const assignIp = id => {
        setSelected(id)
        assignIpNo()
    }

    const assignTempIp = id => {
        setSelected(id)
        assignTempIpNo()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Patient Name, OP/IP No." />

                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <RangePicker
                        onChange={selectRange}
                        ranges={{
                            'Today': [moment().startOf('day'), moment().endOf('day')],
                            'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                            'This Week': [moment().startOf('week'), moment().endOf('week')],
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                        }} />
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Patients</h2>
                </header>
                <div className="p-3">
                    <Receive
                        progress
                        loading={pLoading}
                        error={pError}>
                        {
                            patients?.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Added On</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Latest Visit</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                patients.map((patient, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">
                                                                {
                                                                    select ?
                                                                        <input
                                                                            onChange={() => choose(patient._id)}
                                                                            checked={chosen.includes(patient._id)}
                                                                            type="checkbox"
                                                                            className="form-checkbox cursor-pointer h-5 w-5" />
                                                                        :
                                                                        `${((page - 1) * limit) + (key + 1)}.`
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <Patient patient={patient} />
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{stringifyDate(patient.date)}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{stringifyDate(patient.date)}</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Link to={`/app/accounts/sales/patients/${patient._id}`}>
                                                                <button className="text-white hisani-btn-orange-light font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center">View</button>
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                )}
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">You can add a new patient by clicking above</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
                <Switch>
                    <Route path="/app/accounts/sales/patients/:id">
                        <PatientData reload={refresh} source="/app/accounts/sales/patients" />
                    </Route>
                </Switch>
            </div>
        </div>
    )
}

export default Patients;